import {Component, OnInit} from '@angular/core';
import {SESSION_STORAGE_KEYS} from '../common/session-storage-keys';
import {NotificationPreferenceValue, User} from '../common/user';
import {IDUtil} from "../common/id-util";
import {IDService} from "../common/id.service";
import {UserAuthenticationService} from "../common/user-authentication.service";
import {ConnectDialog} from "../common/confirm-dialog/connect-dialog";
import {ConfirmDialogService} from "../common/confirm-dialog/confirm-dialog.service";
import {MatSlideToggleChange} from "@angular/material/slide-toggle";
import {Router} from "@angular/router";


@Component({
  selector: 'dp-connect-home',
  templateUrl: './connect-home.component.html'
})
export class ConnectHomeComponent implements OnInit{
    user : User;
    appcuesUserIdentification: boolean = false;
    isNotificationOptedIn: boolean = false;

    constructor(private idService: IDService,
                private userAuthenticationService: UserAuthenticationService,
                private  confirmDialogService : ConfirmDialogService,
                private router : Router
    ) {
    }


    ngOnInit(): void {
      let sessionUser : any  = sessionStorage.getItem(SESSION_STORAGE_KEYS.user);
      if(sessionUser  && sessionUser != null) {
          this.user = new User(JSON.parse(sessionUser));
          this.appcuesIdentifyUser();
          this.initializationAfterLogin();
      }
      if(this.user && this.user.isNotificationOptedIn()){
          this.isNotificationOptedIn = true;
      }
    }

    appcuesIdentifyUser() : void {
        if(!this.appcuesUserIdentification){
            this.appcuesUserIdentification = true;

                let appCuesUserObject = {
                    customerAccountId: this.user.customerAccountId,
                    customerAccountName: this.user.customerAccountName,
                    userLoginName: this.user.username,
                    userFirstName: this.user.firstName,
                    userSurname: this.user.lastName,
                    emailAddress: this.user.username,
                };
                console.log(appCuesUserObject);
                (<any>window).Appcues.identify(String(this.user.username), appCuesUserObject);

        }
    }

    initializationAfterLogin() : void {
        IDUtil.setService(this.idService);
        IDUtil.requestIDs();
    }

    async toggleOptOut(event: MatSlideToggleChange) : Promise<void>{
        console.log(event);
        let toProcced: boolean = await this.confirmationToProceed();
        if(toProcced){
            this.user.notificationPreference = this.isNotificationOptedIn ? NotificationPreferenceValue.optIn : NotificationPreferenceValue.optOut;
            this.userAuthenticationService.updateNotificationPreference(this.user.notificationPreference).subscribe();
        } else {
            this.isNotificationOptedIn = !this.isNotificationOptedIn;
        }
    }

    getOptOptionText() : string {
        return this.isNotificationOptedIn ? 'opt-in' : 'opt-out';
    }

    getOptOptionTitle() : string {
        return this.isNotificationOptedIn ? 'Opt Out from receiving automatic notifications from Unity'
            : 'Opt In to receive automatic notifications from Unity';
    }

    async confirmationToProceed() : Promise<boolean>{
        let connectDialog = new ConnectDialog();
        connectDialog.message = `Choosing to ${this.getOptOptionText()} applies only to system generated notifications to Real Estate agents.<br>` +
            `Would you like to proceed?`
        connectDialog.dialogType = 'WARNING';
        return await this.confirmDialogService.confirmDialog(connectDialog).toPromise();
    }

    goToMyCredentials() : void {
        this.router.navigate(['home/my-credentials']);
    }

    goToMyFiles() : void {
        this.router.navigate(['home/connect-list']);
    }

}
